import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersBackgroundJobStatusesResponseType } from "~/domains";

type RequestDataType = {
  page?: number;
};

const request = async ({
  page = 1,
}: RequestDataType): Promise<ApiManagersBackgroundJobStatusesResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersBackgroundJobStatusesResponseType>(
      "/api/managers/background_job_statuses",
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersBackgroundJobStatusesIndex = ({
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersBackgroundJobStatusesResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersBackgroundJobStatusesIndex"],
    ({ pageParam }) => {
      return request({ page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
